import { render, staticRenderFns } from "./AboutBanner.vue?vue&type=template&id=b323da92&scoped=true"
import script from "./AboutBanner.vue?vue&type=script&lang=js"
export * from "./AboutBanner.vue?vue&type=script&lang=js"
import style0 from "./AboutBanner.vue?vue&type=style&index=0&id=b323da92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b323da92",
  null
  
)

export default component.exports